import Upload from './Upload';

export default Upload;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/upload/index.js
// module id = 468
// module chunks = 0